import { useContext, useEffect, useState } from 'react';
import AppForm from '../../../../global/components/forms/appForms/AppForm';
import { gEnums, listTypes } from '../../../../global/enums/globalEnums';
import { settingsHelpers } from '../../../../global/viewSettings/helpers/settingsHelpers';
import { propDefaults } from '../../../../global/viewSettings/settingsProps/settingsAll';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';

export const _seasonFormTypes = {
  currentSeason: 'currentSeason',
  seasonNew: 'seasonNew',
  seasonStart: 'seasonStart',
  currentYear: 'currentYear',
}

const SeasonDetailsForm = (props) => {

  const _asat = gEnums.availableSubActionTypes
  const npei = settingsHelpers.newPropEditItem

  const { currentSeasonals, handleUpdateSeasonalData, seasonFormType, subActionType } = props


  // createSportsSeasonContext 
  const { getSportsSeason, getCreateSportsSeason, ammendSeasonalItem } = useCreateSportsSeason()
  const { sportsSeason_selected, selectedItems, mediaSeason } = getCreateSportsSeason()
  const { year: latestSeason } = selectedItems ?? {}
  const { seasonals } = sportsSeason_selected ?? {}
  const { details: details_create } = seasonals ?? {}


  // const { seasonals: seasonals_sport } = getSportsSeason()

  const { details: details_sport } = currentSeasonals ?? {}

  const _sportsDetails_create = mediaSeason || details_create || details_sport

  const [appFormItems, setAppFormItems] = useState()

  const [currentDetails, setCurrentDetails] = useState()
  const [formData, setFormData] = useState({})

  const handleLocalPropChange = (data_form) => {
    handleUpdateSeasonalData({ key: 'details', data: data_form })
    // ammendSeasonalItem({ key: 'details', data: data_form })
  }

  const handle_parentData = (d) => {
    setFormData(d)
    handleLocalPropChange(d)
  }

  const getDetailsFormProps = {
    currentSeason: {
      // playoffQualityCount: npei('playoffQualityCount', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(4, 1, 6).numbers }),
      sortStandingsByPoints: npei('sortStandingsByPoints', gEnums.formItemTypes.checkbox),
      showMatchesRemainingCount: npei('showMatchesRemainingCount', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(4, 1, 6).numbers }),
      rankingsMax: npei('rankingsMax', gEnums.formItemTypes.slider, null, null, null, { ...propDefaults(10, 1, 16).numbers }),
      surveyIsActive: npei('surveyIsActive', gEnums.formItemTypes.checkbox),
      ignoreHistory: npei('ignoreHistory', gEnums.formItemTypes.checkbox),
      ignoreRankings: npei('ignoreRankings', gEnums.formItemTypes.checkbox),
      ignoreTwitter: npei('ignoreTwitter', gEnums.formItemTypes.checkbox),
      ignoreRss: npei('ignoreRss', gEnums.formItemTypes.checkbox),
      sportsScoringAuthType: npei('sportsScoringAuthType', gEnums.formItemTypes.select, listTypes.sportsScoringAuthTypes, null, null, { breakBefore: 'Scoring' }),
    },
    seasonNew: {
      year: npei('latestSeason'),
      defaultFromLastSeason: npei('defaultFromLastSeason', gEnums.formItemTypes.checkbox),
      defaultSectionsFromLastSeason: npei('defaultSectionsFromLastSeason', gEnums.formItemTypes.checkbox),
      useMediaSeasonBump: npei('useMediaSeasonBump', gEnums.formItemTypes.checkbox),
    },
    currentYear: {
      latestSeason: npei('latestSeason'),
    },
    seasonStart: {
      seasonStartDate: npei('seasonStartDate'),
      seasonEndDate: npei('seasonEndDate'),
      firstPracticeDate: npei('firstPracticeDate'),
      firstPlayDate: npei('firstPlayDate'),
      committeeMeetingDate: npei('committeeMeetingDate'),
      playoffStartDate: npei('playoffStartDate'),
      championshipDate: npei('championshipDate'),
    }
  }

  useEffect(() => {
    switch (subActionType) {
      case _asat.createSeason:
        setCurrentDetails(details_sport || {})
        setFormData(_sportsDetails_create || {})
        break;
      default:
        const cd = {
          latestSeason: latestSeason,
          ...details_sport,
        }
        setFormData(cd)
        setCurrentDetails(details_sport || {})
    }
    // }
    // eslint-disable-next-line 
  }, [details_sport]);

  useEffect(() => {
    let _appFormItems = getDetailsFormProps[seasonFormType];
    setAppFormItems(_appFormItems)
    // eslint-disable-next-line 
  }, [currentDetails]);


  const form_form = () => <AppForm
    appFormItems={appFormItems}
    data_parent={formData}
    handleUpdateParentData={handle_parentData}
  />

  return appFormItems ? form_form() : <div></div>

}

export default SeasonDetailsForm